export var EXTERNAL_SILOS = "($where: silos_bool_exp!) {\n  silos (where: $where) {\n    location\n    current_weight\n    product\n  }\n}";
export var EXTERNALS = "($where: externals_bool_exp!) {\n  externals (where: $where) {\n    location\n    current_weight\n    product\n  }\n}";
export var SILOS = "($where: silos_bool_exp!) {\n  silos (where: $where) {\n    name\n    capacity\n    current_weight\n    location\n    product\n    company\n  }\n}";



//////////////////
// WEBPACK FOOTER
// ./src/queries/inventory.ts
// module id = 153
// module chunks = 1